/**
 * Format a number as currency with 2 decimal places and thousand separators
 * @param value - The numeric value to format
 * @param currency - The currency code (default: 'GBP')
 * @param locale - The locale for formatting (default: 'en-GB')
 * @returns Formatted currency string
 */
export function formatCurrency(value: number | undefined | null, currency: string = 'GBP', locale: string = 'en-GB'): string {
  if (value === undefined || value === null || isNaN(value)) {
    return '0.00';
  }
  
  return value.toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/**
 * Format a number as currency with symbol
 * @param value - The numeric value to format
 * @param currency - The currency code (default: 'GBP')
 * @param locale - The locale for formatting (default: 'en-GB')
 * @returns Formatted currency string with symbol
 */
export function formatCurrencyWithSymbol(value: number | undefined | null, currency: string = 'GBP', locale: string = 'en-GB'): string {
  if (value === undefined || value === null || isNaN(value)) {
    return '£0.00';
  }
  
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

/**
 * Parse a formatted currency string back to a number
 * @param value - The formatted string to parse
 * @returns Numeric value rounded to 2 decimal places
 */
export function parseCurrency(value: string): number {
  const cleaned = value.replace(/[^0-9.-]/g, '');
  const parsed = parseFloat(cleaned);
  if (isNaN(parsed)) {
    return 0;
  }
  return Math.round(parsed * 100) / 100;
}
